import {
  useFindAllCompaniesQuery,
  useFindAllOrdersQuery,
} from '../../api/api-hooks';
import FilterBar from '../../components/FilterBar';
import { Grid, TextField, Typography } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { OrderItemFilter } from './ordersTypes';
import { orderFilterConstraintChecker } from './ordersUtils';

interface Props {
  filters: OrderItemFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: OrderItemFilter;
}

const OrderFilterBar = ({ filters, setFilters, initialFilters }: Props) => {
  const { data: orders } = useFindAllOrdersQuery({});
  const { data: companies } = useFindAllCompaniesQuery({});
  if (orders === undefined || companies === undefined) return null;

  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={orderFilterConstraintChecker}
        children={(
          handler: (event: any, value?: any, label?: string) => void
        ) => [
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'company');
            }}
            value={filters.company}
            options={companies}
            getOptionLabel={(company) => company.companyName}
            style={{ width: 220 }}
            renderInput={(params) => (
              <TextField {...params} label=' Company' variant='outlined' />
            )}
          />,
          <TextField
            name='purchaseOrderName'
            label='PO Name'
            variant='outlined'
            value={filters.purchaseOrderName}
            onChange={handler}
          />,
          <Grid
            container
            justifyContent='flex-start'
            alignItems='center'
            spacing={1}
          >
            <Grid item>
              <Typography>Sold From:</Typography>
            </Grid>
            <Grid item>
              <TextField
                name='orderDateFrom'
                variant='outlined'
                type='date'
                style={{ width: 175 }}
                value={filters.orderDateFrom}
                onChange={handler}
              />
            </Grid>
            <Grid item>
              <Typography>To:</Typography>
            </Grid>
            <Grid item>
              <TextField
                name='orderDateTo'
                variant='outlined'
                type='date'
                style={{ width: 175 }}
                value={filters.orderDateTo}
                onChange={handler}
              />
            </Grid>
          </Grid>,
        ]}
      />
    </>
  );
};

export default OrderFilterBar;
